/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
import { friendsAndFamilyValidateProgramInput } from '../../../dataActions/DataActionExtension.g';

/**
 * Getfriendsandfamilylist Input Action
 */
export class ValidateFriendsAndFamilyInput implements Msdyn365.IActionInput {
    public input: IDataServiceRequest;
    constructor(input: IDataServiceRequest) {
        this.input = input;
    }
    public shouldCacheOutput = () => false;

    public getCacheKey = () => `IVaildateFriendsAndFamilyInput`;
    public getCacheObjectType = () => 'IVaildateFriendsAndFamilyInput';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

/**
 * TODO: Delete this later it's only used when using static data
 */
export interface IValidateFamilyAndFriendsData {
    Status: string;
    Result: {
        Message: string;
        Code: {
            RecipientEmailAddress: string;
            Status: string;
            Code: string;
            SentDate: string;
            ActivationDate: string;
        };
    };
}

export interface IInputRequirements {
    code: string;
    emailListId: string;
    sourceId: string;
}

export const createValidateFriendsAndFamilyInput = (
    args: Msdyn365.ICreateActionContext,
    { code, emailListId, sourceId }: IInputRequirements
): ValidateFriendsAndFamilyInput => {
    return new ValidateFriendsAndFamilyInput(
        friendsAndFamilyValidateProgramInput(
            code,
            emailListId,
            sourceId
        )
    );
};

export async function validateFriendsAndFamilyAction(input: ValidateFriendsAndFamilyInput, ctx: Msdyn365.IActionContext): Promise<IValidateFamilyAndFriendsData> {
    return input.input.execute(ctx);
    // DEBUG return: delete when module is finished
    // return {
    //     Status: 'SUCCESS',
    //     Result: {
    //         Message: '12',
    //         Code: {
    //             RecipientEmailAddress: 'fred.flintstone@email.com',
    //             Status: 'SENT',
    //             Code: '8180fc21-c645-45a2-8f3a-3f62e80ada85',
    //             SentDate: '2020-08-20',
    //             ActivationDate: '2020-08-20'
    //         }
    //     }
    // };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IValidateFamilyAndFriendsData>>validateFriendsAndFamilyAction,
    input: createValidateFriendsAndFamilyInput
});
